import { Component, OnInit, SimpleChanges, Input, ElementRef } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { OrderInputDto } from 'src/app/models/apiRequestModels';

interface OrderNote {
  Id: number;
  UserName: string;
  Message: string;
  CreatedAt: Date;
  isEditing?: boolean;
  editMessage?: string;
}
declare var tippy: any;

@Component({
  selector: 'app-order-information',
  templateUrl: './order-information.component.html',
  styleUrls: ['./order-information.component.css']
})

export class OrderInformationComponent implements OnInit {
  @Input() dataFromParent: any;
  orderResponse: any = [];
  orderInfo: any = [];
  courtInfo: any = [];
  caseNumber: string;
  orderFormData: any = [];
  requestorDetails: any = [];
  courtDetails: any = [];
  addressLines: string[] = [];
  newNote: string = "";
  orderNotes: OrderNote[];
  Notes = "";
  orderId: Number = null;
  currentUserName: string = '';

  constructor(private spinner: NgxSpinnerService,
    private backendService: BackendService, private datePipe: DatePipe, private el: ElementRef) { }
  ngOnInit(): void {
    this.currentUserName = localStorage.getItem('userName') || '';
    // this.spinner.hide();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataFromParent'] && changes['dataFromParent'].currentValue) {
      // console.log('Data received in child:', this.dataFromParent);
      this.orderResponse = this.dataFromParent;
      this.orderId = this.orderResponse.orderId;
      if (this.orderResponse.orderInfo != null) {
        this.orderResponse.orderInfo.modifiedDate = this.orderResponse.orderInfo.modifiedDate !== undefined ? this.convertToLocalFormat(this.orderResponse.orderInfo.modifiedDate) : this.orderResponse.orderInfo.modifiedDate;
        this.orderResponse.orderInfo.createdDate = this.orderResponse.orderInfo.createdDate !== undefined ? this.convertToLocalFormat(this.orderResponse.orderInfo.createdDate) : this.orderResponse.orderInfo.createdDate;
        this.orderInfo = Object.entries(this.orderResponse.orderInfo).map(([key, value]) => ({ key, value }));
      }
      if (this.orderResponse.courtInfo != null) {
        this.orderResponse.courtInfo.hearingDate = this.orderResponse.courtInfo.hearingDate != null ? this.datePipe.transform(this.orderResponse.courtInfo.hearingDate, 'EEE MMMM dd yyyy') : null;
        this.courtInfo = Object.entries(this.orderResponse.courtInfo).map(([key, value]) => ({ key, value }));
      }
      if (this.orderResponse.primaryReq != null) {
        this.requestorDetails = Object.entries(this.orderResponse.primaryReq).map(([key, value]) => ({ key, value }));
      }
      this.caseNumber = this.orderResponse.caseNumber;
      this.orderFormData = this.orderResponse.formData;
      this.orderNotes = this.orderResponse.orderRecord?.notes ? JSON.parse(this.orderResponse.orderRecord.notes) : [];
      this.convertCreatedAtDateToUTC();
    }
  }
  isPaid: boolean = false;

  splitCamelCase(camelCaseString: string): string {
    return camelCaseString
      .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before uppercase letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter of the result
  }
  convertUTCToLocalFormat(utcDate: string): string {
    const localDate = new Date(utcDate);
    //let LocalDate = new Date(formattedDate);
    return this.datePipe.transform(localDate, 'dd MMM yyyy HH:mm').toString() || "";
    //return localDate.toLocaleString();
  }
  refreshNotes() {
    this.spinner.show();
    this.backendService.getOrderDetailsById(this.orderId).subscribe(
      response => {
        this.orderResponse = this.backendService.getJSONResponse(response).data;
        this.spinner.hide();
        this.orderNotes = JSON.parse(this.orderResponse.orderRecord.notes);
        this.convertCreatedAtDateToUTC();
      },
      (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        return null;
      })
  }
  convertCreatedAtDateToUTC() {
    if (this.orderNotes.length > 0) {
      this.orderNotes.forEach((item: any) => {
        item.CreatedAt = item.CreatedAt ? this.convertUTCToLocalFormat(item.CreatedAt) : item.CreatedAt;
      });
    }
  }
  private async updateNotesOnBackend(updatedNotes: any[]) {
    this.spinner.show();

    const orderCreateModel = new OrderInputDto();
    orderCreateModel.Notes = JSON.stringify(updatedNotes);

    this.backendService.UpdateOrderNotes(orderCreateModel, this.orderId).subscribe(
      res => {
        const result = this.backendService.getJSONResponse(res);
        if (result.data.message === "Order Notes updated successfully.") {
          this.orderNotes = result.data?.notes ? JSON.parse(result.data.notes) : [];
          this.convertCreatedAtDateToUTC();
        }
        this.spinner.hide();
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
        this.spinner.hide();
      }
    );
  }
  async sendNote() {
    const noteText = this.newNote.trim();
    if (!noteText) return;

    const newNote = {
      Id: this.orderNotes.length > 0 ? Math.max(...this.orderNotes.map(n => n.Id)) + 1 : 1,
      UserName: localStorage.getItem('userName'),
      Message: noteText,
      CreatedAt: new Date()
    };

    const updatedNotes = [...this.orderNotes, newNote];
    await this.updateNotesOnBackend(updatedNotes);
    this.newNote = '';
  }
  async updateNote(index: number) {
    const note = this.orderNotes[index];
    if (!note.editMessage || note.editMessage.trim() === '') return;

    note.Message = note.editMessage.trim();
    note.CreatedAt = new Date();
    note.isEditing = false;
    note.editMessage = '';

    await this.updateNotesOnBackend(this.orderNotes);
  }
  async deleteNote(index: number) {
    this.orderNotes.splice(index, 1);
    await this.updateNotesOnBackend(this.orderNotes);
  }
  editNote(index: number) {
    const note = this.orderNotes[index];
    note.isEditing = true;
    note.editMessage = note.Message;
  }
  cancelEdit(index: number) {
    const note = this.orderNotes[index];
    note.isEditing = false;
    note.editMessage = '';
  }
  ngAfterViewInit() {
    setTimeout(() => {
      tippy(this.el.nativeElement.querySelectorAll('[data-tippy-content]'), {
        placement: 'bottom',
        arrow: true,
        trigger: 'mouseenter focus',
      });
    }, 4000);
  }
  private convertToLocalFormat(dateString: string): string {
    if (dateString === "0001-01-01T00:00:00" || !dateString) {
      return ""; 
    }
    let date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string passed to convertToLocalFormat:', dateString);
      return "Invalid Date"; 
    }
    var formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss UTC');
    let LocalDate = new Date(formattedDate);
    return this.datePipe.transform(LocalDate, 'EEE MMMM dd yyyy HH:mm').toString() || ""; 
  }
}